import { kea } from 'kea'
import PropTypes from 'prop-types';
import { find } from 'lodash'
import {fullPush, selector as configSelector} from '~/config'

import entities from '~/entities'
import { workers as shopSearchWorkers } from '~/entities/shop-searches'
import {call, put} from "redux-saga/effects";

export default kea({
  path : () => ['components', 'search'],

  actions : ({ constants }) => ({
    show: true,
    hide: true,
    toggle: true,
    initialize: true,
    initializeFail: true,
    search: (val) => ({val}),
    clear: true,
    changeTab: (tab) => ({tab}),
    navigateTo: (path) => ({path})
  }),

  reducers : ({ actions, constants }) => ({
    visible: [false, PropTypes.bool, {
      [actions.show]: () => true,
      [actions.hide]: () => false,
      [actions.toggle]: (_) => (!_),
    }],
    searchValue: ['', PropTypes.string, {
      [actions.search]: (_, payload) => (payload.val),
      [actions.clear]: () => (''),
      [actions.hide]: () => (''),
    }],
    activeTab: ['products', PropTypes.string, {
      [actions.changeTab]: (_, payload) => (payload.tab)
    }],
    isInitialized: [false, PropTypes.bool, {
      [actions.initialize]: () => true,
    }],
    initializeFailed: [false, PropTypes.bool, {
      [actions.initializeFail]: () => true,
    }]
  }),

  selectors : ({ constants, selectors }) => ({
    activeShop: [
      () => [
        configSelector,
        entities.selectors.shops
      ],
      (config, shops) => {
        const { activeShop } = config;
        if(activeShop && shops) {
          const shop = find(shops, {url: activeShop});

          if(shop) {
            return shop;
          }
        }
        return null;
      },
      PropTypes.object
    ],
    search: [
      () => [
        selectors.activeShop,
        entities.selectors.shopSearches,
      ],
      (activeShop, shopSearches) => {
        if(activeShop) {
          const shopSearch = find(shopSearches, {id: activeShop.id});

          if(shopSearch) {
            return shopSearch;
          }
        }

        return null;
      },
      PropTypes.object
    ],
    productSearchConfig: [
      () => [
        selectors.search
      ],
      (search) => {
        if(search) {
          return {
            appId: search.application_id,
            apiKey: search.token,
            indexName: search.product_index,
          }
        }
        return null;
      },
      PropTypes.object
    ],
    orderSearchConfig: [
      () => [
        selectors.search
      ],
      (search) => {
        if(search) {
          return {
            appId: search.application_id,
            apiKey: search.token,
            indexName: search.order_index,
          }
        }
        return null;
      },
      PropTypes.object
    ],
  }),

  takeEvery: ({ actions, workers }) => ({
    [actions.navigateTo]: workers.navigateToWorker
  }),

  takeLatest: ({ actions, workers }) => ({
    [actions.show]: workers.initWorker,
    [actions.toggle]: workers.initWorker,
  }),

  workers: {
    initWorker: function * () {
      console.log('init worker');
      const visible = yield this.get('visible');
      if(visible) {
        const activeShop = yield this.get('activeShop');
        const { initialize, initializeFail } = this.actions;
        if(activeShop) {
          try {
            const isInitialized = yield this.get('isInitialized');
            const initializeFailed = yield this.get('initializeFailed');

            if(!isInitialized && !initializeFailed) {
              const shopSearch = yield call(shopSearchWorkers.fetch, {payload: {
                  id: activeShop.id
                }});

              yield put(initialize());
            }
          } catch (e) {
            console.error(e);
            yield put(initializeFail());
          }
        }
      }
    },

    navigateToWorker: function * (action) {
      const { path } = action.payload || {};
      const { hide } = this.actions;
      try {

        yield put(hide());
        yield put(fullPush(path));

      } catch (e) {
        console.error(e);
      }
    }
  }
})
